var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('el-container',[_c('el-aside',{attrs:{"width":"none"}},[_c('AsideMenu')],1),_c('el-container',[_c('el-header',{staticStyle:{"height":"50px"}},[_c('Header')],1),_c('el-main',[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }